var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 19,
    viewBox: "0 0 132 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05625 0L8.26266 12.2719L12.209 0H16.0567L20.003 12.2719L23.2094 0H28.2657L22.7161 19H17.7832L14.1328 7.98806L10.4825 19H5.54955L0 0H5.05625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5403 0V19H31.706V0H36.5403Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9052 19V0H46.7395L55.6681 11.6167V0H60.4777V19H55.6681L46.7395 7.38329V19H41.9052Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8579 19V0H70.6922L79.6208 11.6167V0H84.4304V19H79.6208L70.6922 7.38329V19H65.8579Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6448 0V19H89.8105V0H94.6448Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.064 4.18302V19H102.23V4.18302H98.2586V0H111.035V4.18302H107.064Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.358 9.87798L113.576 0H119.347L122.8 5.19098L126.228 0H132L125.193 9.87798V19H120.358V9.87798Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.4e20fbeef9d58851fa150a8ff4593f49.svg";
export { ForwardRef as ReactComponent };